import { app } from "../config/config";

export const handleRedirect = () => {
  const currentUrl = new URL(window.location.href);

  const redirectUrl = new URL("login", app.accountUrl);

  redirectUrl.searchParams.append("redirect", currentUrl.href);

  window.location.href = redirectUrl.href;
};
